export default function compile($compile) {
    return {
        restrict: 'A',
        replace: true,
        link: (scope, element, attrs) => {
            scope.$watch(attrs.compile, html => {
                element.html(html);
                $compile(element.contents())(scope);
            });
        }
    }
};
